import { type JSX, useEffect } from "react";
import styled from "styled-components";
import { currentColors } from "../../shared/colors";
import t from "../../shared/translations";

interface IProps {
    setCopied: (value: boolean) => void;
}

const Holder = styled.div`
    color: ${currentColors.success};
    white-space: nowrap;
    display: grid;
    place-items: center;
`;

function CopiedText({ setCopied }: IProps): JSX.Element {
    useEffect(() => {
        const timer = setTimeout(() => setCopied(false), 10000);
        return () => {
            clearTimeout(timer);
        };
    }, [setCopied]);

    return <Holder>{t("player.pulse-results.info-link-copied")}</Holder>;
}

export default CopiedText;
